import type { JsonValue } from "@/api/json";

export const money = (value: JsonValue | undefined, currency = "ARS") =>
  new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency,
    minimumFractionDigits: 2
  }).format(Number(value ?? 0));

export const shortDate = (value?: string | null) =>
  value ? new Intl.DateTimeFormat("es-AR", { timeZone: "UTC" }).format(new Date(value)) : "—";

export const percent = (value: JsonValue | undefined) => `${Math.round(Number(value ?? 0) * 100)}%`;

export const statusClass = (status: string) => {
  if (["AUTO", "APPROVED", "ADJUSTED", "CONFIRMED", "CONCILIATED", "VALID", "COMMITTED"].includes(status)) return "success";
  if (["SUGGESTED", "PREVIEW", "REVIEW", "WARNING"].includes(status)) return "warning";
  if (["FAILED", "ERROR", "REJECTED"].includes(status)) return "error";
  if (["PROCESSING", "QUEUED"].includes(status)) return "info";
  return "neutral";
};
